__turbopack_context__.v({
  "draggable": "_5O90_a_draggable",
  "draggableIcon": "_5O90_a_draggableIcon",
  "error": "_5O90_a_error",
  "image": "_5O90_a_image",
  "root": "_5O90_a_root",
});
